
export const handleLanguage = () => {
    const langs = ["en", "ru", "cn"]
    const urlPath = window.location.pathname
    const urlPathList = urlPath.split("/").filter(el => el.length > 0)
    const selectedLangs = Array.from(document.querySelectorAll(".site-header__lang-dropdown-selected-item")) as Array<HTMLElement>
    const langsOptions = Array.from(document.querySelectorAll(".site-header__lang-dropdown-item")) as Array<HTMLLinkElement>

    if (urlPathList.length > 0) {
        const currLang = langs.find(el => el === urlPathList[0]) ? langs.find(el => el === urlPathList[0]) : langs[0]
        const selectedLang = selectedLangs.find(el => el.getAttribute("data-lang") === currLang)
        const selectedLangOption = langsOptions.find(el => el.getAttribute("data-lang") === currLang)

        if (selectedLang && selectedLangOption) {
            selectedLang.style.display = "flex"
            selectedLangOption.style.display = "none"
        }
    } else {
        const currLang = selectedLangs.find(el => el.getAttribute("data-lang") === langs[0])
        const selectedLangOption = langsOptions.find(el => el.getAttribute("data-lang") === langs[0])

        if (currLang && selectedLangOption) {
            currLang.style.display = "flex"
            selectedLangOption.style.display = "none"
        }
    }

    if (urlPathList.length > 0) {
        langsOptions.forEach(el => {
            el.href = `${el.href}${urlPathList.filter(el => !langs.includes(el)).join("/")}`
        })
    }
}
